const CopFreightSearchComponent = () => import('@/views/cop/cop/CopFreightSearchView')

export default [
    {
        path:'/CopFreightSearch',
        name:'CopFreightSearchComponent',
        component:CopFreightSearchComponent
    }
]